import React, { useState } from 'react';
import logo from "../../images/logo_black.png";
import Swal from 'sweetalert2';


const DeleteAccountDemo = () => {
    const [confirmed, setConfirmed] = useState(false);
    const [email, setEmail] = useState('');

    const handleDelete = async (e) => {
        e.preventDefault();

        await Swal.fire({
            title: 'Account deleted successfully',
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#f06262'
        });

        // Reset the form
        setEmail('');
        setConfirmed(false);
    };

    return (
        <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light py-5">
            <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
                <div className="card shadow-lg border-0 overflow-hidden" style={{ borderRadius: '12px' }}>
                    <div className="text-white text-center py-5 px-4" style={{ backgroundColor: '#f06262' }}>
                        <div className="d-inline-flex align-items-center justify-content-center bg-white rounded-circle mb-3 shadow-sm" style={{ width: '90px', height: '90px' }}>
                            <img src={logo} alt="W" style={{ width: '60px', objectFit: 'contain' }} />
                        </div>
                        <h1 className="fw-bold mb-2" style={{ fontSize: '2.5rem' }}>Account Deletion</h1>
                    </div>

                    <div className="card-body p-4 p-md-4 bg-white">
                        <div className="p-4 mb-4 rounded" style={{ backgroundColor: '#fffdf0', border: '1px solid #f9e8a5' }}>
                            <div className="d-flex align-items-start mb-3">
                                <span className="text-warning me-2" style={{ fontSize: '1.2rem' }}>⚠️</span>
                                <h5 className="fw-bold mb-0" style={{ color: '#856404', fontSize: '1.1rem' }}>Before you proceed</h5>
                            </div>
                            <ul className="mb-0 ps-4" style={{ color: '#967305', fontSize: '0.95rem', listStyleType: 'disc' }}>
                                <li className="mb-2">Your Somadome account and all associated data will be permanently deleted.</li>

                            </ul>
                        </div>

                        <form onSubmit={handleDelete}>
                            <div className="p-4 mb-4 border rounded bg-white shadow-sm" style={{ borderColor: '#e9ecef' }}>
                                <h6 className="fw-bold mb-3 text-dark">Email Verification</h6>
                                <input
                                    type="email"
                                    className="form-control form-control-lg border-2"
                                    placeholder="Enter your registered email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="p-4 mb-4 border rounded bg-white shadow-sm d-flex align-items-start" style={{ borderColor: '#e9ecef' }}>
                                <input
                                    className="form-check-input me-3"
                                    type="checkbox"
                                    id="confirmDelete"
                                    checked={confirmed}
                                    onChange={(e) => setConfirmed(e.target.checked)}
                                    style={{ cursor: 'pointer', width: '20px', height: '20px' }}
                                />
                                <label className="form-check-label text-dark" htmlFor="confirmDelete" style={{ cursor: 'pointer' }}>
                                    <div className="fw-bold mb-1" style={{ fontSize: '1rem' }}>I understand that this action cannot be undone</div>
                                    <div className="text-muted" style={{ fontSize: '0.9rem' }}>I confirm that I want to permanently delete my account and all associated data.</div>
                                </label>
                            </div>

                            <button
                                type="submit"
                                className={`btn btn-lg w-100 py-3 fw-bold text-white shadow-sm`}
                                disabled={!confirmed || !email}
                                style={{
                                    borderRadius: '6px',
                                    backgroundColor: (confirmed && email) ? '#f06262' : '#d2d6da',
                                    borderColor: (confirmed && email) ? '#f06262' : '#d2d6da'
                                }}
                            >
                                Delete My Account
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteAccountDemo;
